import { createFileRoute } from '@tanstack/react-router';

import InstallationDetails from '@/ui/pages/InstallationDetails/InstallationDetails';

export const Route = createFileRoute('/_dashboard/installations/$id/')({
  component: InstallationDetails,
});
